import axios from "@/axios.js";

function mapComplaintSuggestion(item) {
  if (!item) return null;

  return {
 
    ID: item.Id || item.id,
    Code: item.ComplaintCode || item.complaintCode,
    Title: item.Title || item.title,
    Content: item.Content || item.content,
    Type: item.Type || item.type, // 1: Complaint, 2: Suggestion
    Status: item.Status !== undefined ? (item.Status || item.status) : null, 
    AttachmentUrl: item.AttachmentUrl || item.attachmentUrl,
    InvestorId: item.InvestorId || item.investorId,
    UserName: item.UserName || item.UserName,
    AdminReply: item.AdminReply || item.adminReply || "",


    Id: item.Id,
    ComplaintCode: item.ComplaintCode,
    TitleRaw: item.Title,
    ContentRaw: item.Content,
    TypeRaw: item.Type,
    StatusRaw: item.Status,
    AttachmentUrlRaw: item.AttachmentUrl,
    InvestorIdRaw: item.InvestorId,
    IsDeleted: item.IsDeleted,
    CreatedDate: item.CreatedDate,
    UpdatedAt: item.UpdatedAt,


    id: item.id,
    complaintCode: item.complaintCode,
    title: item.title,
    content: item.content,
    type: item.type,
    status: item.status,
    attachmentUrl: item.attachmentUrl,
    investorId: item.investorId,
    adminReply: item.adminReply
  };
}

function mapCreateUpdatePayload(item) {
  return {
    Id: item.ID || item.Id || item.id || 0,
    Title: item.Title || item.title || "",
    Content: item.Content || item.content || "",
    Type: item.Type || item.type || 1, 
    Status: item.Status !== undefined ? item.Status : (item.status !== undefined ? item.status : null),
    AttachmentUrl: item.AttachmentUrl || item.attachmentUrl || "",
    InvestorId: item.InvestorId || item.investorId || 0
    // ملاحظة: ComplaintCode غالباً بيتولد في الـ Backend فمش محتاجين نبعته في الـ Add
  };
}

function getResponseData(response, fallback = null) {
  if (!response || !response.data) return fallback;
  return response.data.data || response.data.Data || fallback;
}

export default {
  fetchDataListItems({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/api/ComplaintSuggestion/GetAll")
        .then((response) => {
          const raw = getResponseData(response, []);
          const payload = Array.isArray(raw) ? raw.map(mapComplaintSuggestion) : [];
          commit("SET_ITEMS", payload);
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  },

  GetItemByID({ commit }, itemid) {
  
    return new Promise((resolve, reject) => {
  
      axios.get(`API/ComplaintSuggestion/GetById/${itemid}`, {
        headers: { Authorization: 'Bearer ' + localStorage.accessToken }
      })
      .then((response) => {
      
        commit('GET_ITEM_BY_ID', response.data.Data); 
        resolve(response);
      })
      .catch((error) => { reject(error) });
    });
  },
  
  addItem({ commit }, item) {
    const payloadToApi = mapCreateUpdatePayload(item);

    return new Promise((resolve, reject) => {
      axios
        .post("/api/ComplaintSuggestion/Add", payloadToApi)
        .then((response) => {
          const raw = getResponseData(response, payloadToApi);
          const payload = mapComplaintSuggestion(raw);
          commit("ADD_ITEM", payload);
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  },

  updateItem({ commit }, item) {
    const payloadToApi = mapCreateUpdatePayload(item);

    return new Promise((resolve, reject) => {
      axios
        .put("/api/ComplaintSuggestion/Update", payloadToApi)
        .then((response) => {
          const raw = getResponseData(response, payloadToApi);
          const payload = mapComplaintSuggestion(raw);
          commit("UPDATE_ITEM", payload);
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
// داخل ملف module actions
 markAsResolved({ commit }, item) {
  return new Promise((resolve, reject) => {
    axios
      .put("/api/ComplaintSuggestion/MarkAsResolved", item)
      .then((response) => {
        const raw = getResponseData(response, item);
        const payload = mapComplaintSuggestion(raw);

        commit("UPDATE_ITEM", payload);
        resolve(response);
      })
      .catch((error) => reject(error));
  });
},
  removeItem({ commit }, item) {
    const id = item && (item.ID || item.Id) ? (item.ID || item.Id) : item;

    return new Promise((resolve, reject) => {
      axios
        .delete("/api/ComplaintSuggestion/Delete/" + id)
        .then((response) => {
          commit("REMOVE_ITEM", id);
          resolve(response.data || response);
        })
        .catch((error) => reject(error));
    });
  }
  
};